import { createFileRoute } from '@tanstack/react-router'

import { GuaranteesPageSkeleton } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page-skeleton.tsx'
import { GuaranteesPage } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/product-guarantees/')({
  loader: async ({ context }) => {
    const { queryClient, trpc } = context
    void queryClient.prefetchQuery(trpc.invoices.hasUnpaidInvoices.queryOptions(undefined, frontOfficeQueryOptions))
    await queryClient.ensureQueryData(trpc.contracts.listMyContracts.queryOptions(undefined, frontOfficeQueryOptions))
  },
  pendingComponent: GuaranteesPageSkeleton,
  pendingMs: 150,
  component: GuaranteesPage,
})
